import React from 'react';
import { Box, Flex, Heading } from '@chakra-ui/react';

interface IMFAHeaderProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

const MFAHeader = (props: IMFAHeaderProps) => {
  const { icon, children } = props;

  return (
    <>
      <Flex alignItems={'center'} mb={8}>
        <Box display={{ base: 'none', sm: 'block' }} fontSize={'1.75rem'} mr={4}>
          {icon}
        </Box>

        <Heading as="h1" data-selector="mfa-auth-heading" fontSize={{ base: '2xl', sm: '3xl' }} lineHeight={'shorter'}>
          {children}
        </Heading>
      </Flex>
    </>
  );
};

export { MFAHeader };
